import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,Textarea} from "@chakra-ui/react"
import { m } from "framer-motion";
interface props {
    isModalOpen:boolean;
    title:string;
    message:string;
    onClose:()=>void;    
    onCancel:()=>void;
}

export const FullNotifyBoxModal=({isModalOpen,title,message,onClose,onCancel}:props)=>{
    return(
        <Modal
            closeOnOverlayClick={false}
            isOpen={isModalOpen}
            onClose={onClose}
            size='sm'>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader className='!font-normal'>{title}</ModalHeader>
                <ModalCloseButton />

                <ModalBody pb={6}>
                    {message.split('\n').map((line, index) => (
                    <div key={index}>{line}</div>
            ))}
                </ModalBody>

                <ModalFooter className='gap-4'>
                    <Button colorScheme='orange' className="w-full" onClick={() => { onClose()}}>OK</Button>
                    <Button colorScheme='orange' className="w-full" onClick={() => { onCancel();}}>Cancel</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}